function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#gradient-1);\n      }\n\n      .cls-2 {\n        fill: url(#gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient-1",
  x1: 40.67,
  y1: 63.95,
  x2: 77.7,
  y2: 63.95,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 111.94)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#33ffd3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3bf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient-2",
  x1: 0.19,
  y1: 52.48,
  x2: 58.28,
  y2: 52.48,
  xlinkHref: "#gradient-1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient-3",
  x1: 0.19,
  y1: 81.81,
  x2: 37.21,
  y2: 81.81,
  xlinkHref: "#gradient-1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient-4",
  x1: 19.61,
  y1: 93.4,
  x2: 77.7,
  y2: 93.4,
  xlinkHref: "#gradient-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M46.49,34.57c1.73.49,3.58.28,5.33.74a13,13,0,0,1,1.45,24.88c-3,1.18-6.41.45-9.14,2.35A8,8,0,1,0,55.61,73a10.21,10.21,0,0,0,1-4.55A13.4,13.4,0,0,1,68.93,56a11.29,11.29,0,0,0,4.14-.8,8.19,8.19,0,0,0,3.14-2.55,8.05,8.05,0,0,0-5.29-12.57,27,27,0,0,1-5.29-.82A13.22,13.22,0,0,1,61.56,37,13.54,13.54,0,0,1,57,29.55c-.36-1.59-.19-3.26-.62-4.83a8,8,0,1,0-13.2,7.9A7.79,7.79,0,0,0,46.49,34.57Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M42.63,46.85c-.49,1.73-.28,3.58-.74,5.33A13,13,0,0,1,17,53.6c-1.18-3-.45-6.41-2.35-9.14A8,8,0,1,0,4.27,56a10.24,10.24,0,0,0,4.55,1A13.41,13.41,0,0,1,21.2,69.29a11.5,11.5,0,0,0,.8,4.14,8,8,0,0,0,15.12-2.15A27.29,27.29,0,0,1,37.94,66a13.28,13.28,0,0,1,2.28-4.07,13.54,13.54,0,0,1,7.42-4.59c1.59-.36,3.26-.19,4.83-.62a8,8,0,1,0-7.9-13.2A7.9,7.9,0,0,0,42.63,46.85Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M31.4,43.46c-1.73-.49-3.58-.28-5.33-.74A13.37,13.37,0,0,1,16.5,33a13.27,13.27,0,0,1,8.15-15.13c3-1.18,6.41-.45,9.14-2.35A8,8,0,1,0,22.27,5.05a10.24,10.24,0,0,0-1,4.55A13.4,13.4,0,0,1,9,22a11.5,11.5,0,0,0-4.14.8,8.2,8.2,0,0,0-3.15,2.6A8,8,0,0,0,3.59,36.59,7.86,7.86,0,0,0,7,38a27.74,27.74,0,0,1,5.29.82,13.41,13.41,0,0,1,8.66,9.7c.36,1.59.19,3.26.62,4.83a8,8,0,1,0,13.2-7.9A7.88,7.88,0,0,0,31.4,43.46Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M35.27,31.18c.49-1.73.28-3.58.74-5.33a13,13,0,0,1,24.88-1.42c1.18,3,.45,6.41,2.35,9.14A8,8,0,1,0,73.67,22.05a10.38,10.38,0,0,0-4.55-1A13.39,13.39,0,0,1,56.69,8.74a11.5,11.5,0,0,0-.8-4.14,8.19,8.19,0,0,0-2.55-3.14A8.06,8.06,0,0,0,40.77,6.75,27,27,0,0,1,40,12a13.28,13.28,0,0,1-2.28,4.07,13.45,13.45,0,0,1-7.4,4.59c-1.59.36-3.26.19-4.83.62a8,8,0,1,0,7.83,13.2A7.89,7.89,0,0,0,35.27,31.18Z"
});

function SvgRhizomeDao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77.87 78.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhizomeDao);
export default __webpack_public_path__ + "static/media/rhizome-dao.027acd0b.svg";
export { ForwardRef as ReactComponent };